<div class="bg-white/20 rounded-lg shadow-sm border border-gray-100 p-6 max-w-sm mx-auto">
  <!-- En-tête du calendrier -->
  <div class="flex items-center justify-between mb-3">
    <button 
      (click)="previousMonth()" 
      class="text-gray-600 hover:text-gray-900 transition-colors p-1">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
      </svg>
    </button>
    
    <h2 class="!text-[14px] font-bold text-gray-900">
      {{ getCurrentMonthYear() }}
    </h2>
    
    <button 
      (click)="nextMonth()" 
      class="text-gray-600 hover:text-gray-900 transition-colors p-1">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
      </svg>
    </button>
  </div>

  <!-- Jours de la semaine -->
  <div class="grid grid-cols-7 gap-1">
    <div *ngFor="let day of weekDays" class="text-center text-sm font-medium text-gray-500 py-2">
      {{ day }}
    </div>
  </div>

  <!-- Grille du calendrier -->
  <div class="grid grid-cols-7 gap-1">
    <div 
      *ngFor="let day of calendarDays" 
      class="h-10 flex items-center justify-center text-sm cursor-pointer transition-colors relative"
      [class]="getDayClasses(day)"
      (click)="selectDate(day.date)"
      [title]="getDayTooltip(day.date)">
      
      <!-- Numéro du jour -->
      <span [class]="getDayNumberClasses(day)">
        {{ day.dayNumber }}
      </span>
      
      <!-- Indicateurs colorés pour les événements -->
      <div *ngIf="getEventsForDate(day.date).length > 0" class="absolute bottom-1 left-1/2 transform -translate-x-1/2 flex space-x-0.5">
        <div 
          *ngFor="let event of getEventsForDate(day.date).slice(0, 3)" 
          class="w-1.5 h-1.5 rounded-full"
          [class]="getEventColor(event)">
        </div>
        <div 
          *ngIf="getEventsForDate(day.date).length > 3" 
          class="w-1.5 h-1.5 rounded-full bg-gray-400">
        </div>
      </div>
    </div>
  </div>

</div>

  <!-- Section des événements détaillée -->
  <div *ngIf="selectedDate && getEventsForDate(selectedDate).length > 0" class="mt-4 pt-4 border-t border-gray-100">
    <h4 class="!text-[14px] font-medium text-gray-700 mb-3">Événements du {{ getSelectedDateFormatted() }}</h4>
    <div class="space-y-2">
      <div 
        *ngFor="let event of getEventsForDate(selectedDate)" 
        (click)="onEventClick(event, $event)"
        class="p-3 rounded-lg border border-gray-200 cursor-pointer transition-all bg-white/50 hover:bg-white/80">
        
        <div class="flex items-start justify-between">
          <div class="flex-1">
            <div class="flex items-center gap-2 mb-1">
              <div class="w-3 h-3 rounded-full" [class]="getEventColor(event)"></div>
              <h5 class="text-sm font-medium text-gray-900">{{ event.title }}</h5>
            </div>
            <p class="text-xs text-gray-600 mb-1">{{ event.description }}</p>
            <div class="flex items-center gap-4 text-xs text-gray-500">
              <span>🕐 {{ getEventTimeRange(event) }}</span>
              <span *ngIf="event.location">📍 {{ event.location }}</span>
              <span *ngIf="event.doctor">👨‍⚕️ {{ event.doctor }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>